import React from 'react'
import JdCreation from '../Company/JD/JdCreation'

function Jd() {
  return (
    <>
        <JdCreation />
    </>
  )
}

export default Jd
